import React from 'react';
import Layout from '../components/Layout';
import ServiceComponent from '../components/Services';

export default function Services() {
  return (
    <Layout>
      <ServiceComponent />
    </Layout>
  );
}
